import {
  useSchedulerRangeData,
  useSchedulerPropsContext,
} from '../../context/schedulerContext'
import { MultiDaySlotLayout } from '../../components/MultiDaySlotLayout/MultiDaySlotLayout'

export function WeekdaySlotView() {
  const { visibleDays, cellTimeSlots } = useSchedulerRangeData()
  const { events } = useSchedulerPropsContext()

  return (
    <MultiDaySlotLayout
      weekDayDates={visibleDays}
      cellTimeSlots={cellTimeSlots}
      events={events}
    />
  )
}
